import * as React from "react";

export type MenuListProps = React.HTMLProps<HTMLUListElement>;

export default function MenuList(props: MenuListProps) {
	const { className, ...restProps } = props;
	return <ul className={"menu-list " + (className ? className : "")} {...restProps}>
		{props.children}
	</ul>;
}